import type { DigitalProductTracking } from '../../types';

export const defaultTracking: DigitalProductTracking = { meta: [], google: [], tiktok: [], snack: [], openai: [] };

/** Label customer-friendly: hapus branding gateway dari nilai tersimpan ("Duitku QRIS" → "QRIS"). */
export const displayPaymentMethod = (m: string): string => m.replace(/^(Duitku|iPaymu)\s+/i, '');

export const PLATFORMS = [
  { key: 'meta' as const, label: 'Meta Pixel', color: 'bg-blue-600', placeholder: '1234567890123456' },
  { key: 'google' as const, label: 'Google Analytics', color: 'bg-amber-500', placeholder: 'G-XXXXXXXXXX' },
  { key: 'tiktok' as const, label: 'TikTok Pixel', color: 'bg-indigo-600', placeholder: 'TikTok Pixel ID' },
  { key: 'snack' as const, label: 'Snack Video', color: 'bg-emerald-500', placeholder: 'Snack Pixel ID' },
  { key: 'openai' as const, label: 'OpenAI Ads', color: 'bg-teal-600', placeholder: 'OpenAI Pixel ID' },
] as const;

export const PAYMENT_OPTIONS = [
  { value: 'BCA Virtual Account', label: 'BCA Virtual Account', gateway: 'midtrans' as const },
  { value: 'BNI Virtual Account', label: 'BNI Virtual Account', gateway: 'midtrans' as const },
  { value: 'BRI Virtual Account', label: 'BRI Virtual Account', gateway: 'midtrans' as const },
  { value: 'Mandiri Virtual Account', label: 'Mandiri Virtual Account', gateway: 'midtrans' as const },
  { value: 'Permata Virtual Account', label: 'Permata Virtual Account', gateway: 'midtrans' as const },
  { value: 'Bank Transfer', label: 'Bank Transfer (semua VA)', gateway: 'midtrans' as const },
  { value: 'GoPay', label: 'GoPay', gateway: 'midtrans' as const },
  { value: 'ShopeePay', label: 'ShopeePay', gateway: 'midtrans' as const },
  { value: 'DANA', label: 'DANA', gateway: 'midtrans' as const },
  { value: 'OVO', label: 'OVO', gateway: 'midtrans' as const },
  { value: 'QRIS', label: 'QRIS', gateway: 'midtrans' as const },
  { value: 'Indomaret', label: 'Indomaret', gateway: 'midtrans' as const },
  { value: 'Alfamart', label: 'Alfamart', gateway: 'midtrans' as const },
  { value: 'Kredivo', label: 'Kredivo', gateway: 'midtrans' as const },
  { value: 'Akulaku', label: 'Akulaku', gateway: 'midtrans' as const },
  { value: 'Kartu Kredit', label: 'Kartu Kredit', gateway: 'midtrans' as const },
  { value: 'Duitku BCA Virtual Account', label: 'BCA Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku Mandiri Virtual Account', label: 'Mandiri Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku BRI Virtual Account', label: 'BRI Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku BNI Virtual Account', label: 'BNI Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku Permata Virtual Account', label: 'Permata Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku CIMB Niaga Virtual Account', label: 'CIMB Niaga Virtual Account (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku QRIS', label: 'QRIS (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku OVO', label: 'OVO (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku DANA', label: 'DANA (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku ShopeePay', label: 'ShopeePay (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku LinkAja', label: 'LinkAja (Duitku)', gateway: 'duitku' as const },
  { value: 'Duitku Kartu Kredit', label: 'Kartu Kredit (Duitku)', gateway: 'duitku' as const },
  { value: 'iPaymu QRIS', label: 'QRIS (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu BCA Virtual Account', label: 'BCA VA (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu BNI Virtual Account', label: 'BNI VA (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu BRI Virtual Account', label: 'BRI VA (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu Mandiri Virtual Account', label: 'Mandiri VA (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu DANA', label: 'DANA (iPaymu)', gateway: 'ipaymu' as const },
  { value: 'iPaymu ShopeePay', label: 'ShopeePay (iPaymu)', gateway: 'ipaymu' as const },
];

export const TESTIMONIAL_NAMES = [
  'Sarah', 'Rina', 'Dewi', 'Ani', 'Maya', 'Sari', 'Fitri', 'Rani', 'Intan', 'Wulan',
  'Vina', 'Nia', 'Ayu', 'Putri', 'Diah', 'Ratna', 'Yuni', 'Siska', 'Lina', 'Tari',
];

export const TESTIMONIAL_CITIES = [
  'Jakarta', 'Bandung', 'Surabaya', 'Bekasi', 'Tangerang', 'Bogor', 'Depok',
  'Semarang', 'Makassar', 'Medan', 'Yogyakarta', 'Malang', 'Palembang', 'Denpasar', 'Balikpapan',
];

export const TOOLBAR_BTN =
  'px-2 py-1 text-xs border border-slate-400 dark:border-slate-500 rounded bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition font-medium';
